const DATEPICKER_PATTERN =
  /\$\(\s*["']\[id\^=['"]?([\w]+)['"]?\]["']\s*\)\s*\.datepicker\(\s*["']option["']\s*,\s*["'](minDate|maxDate)["']\s*,\s*(new\s+Date\s*\(\s*\)|"[^"]*"|'[^']*')\s*\)/g;

export function detectDatepickerConstraints(script, ownerFieldKey) {
  if (!script) return [];
  const rules = [];

  let match;
  DATEPICKER_PATTERN.lastIndex = 0;
  while ((match = DATEPICKER_PATTERN.exec(script)) !== null) {
    const targetPrefix = match[1];
    const kind = match[2];
    const rawValue = (match[3] || '').trim();

    const value = normaliseDatepickerValue(rawValue);
    if (!value) continue;

    if (ownerFieldKey && !ownerFieldKey.startsWith(targetPrefix)) continue;

    rules.push({
      rule: kind,
      value,
      message:
        kind === 'maxDate'
          ? "Date can't be of future."
          : "Date is below the allowed minimum.",
    });
  }

  return rules;
}

function normaliseDatepickerValue(raw) {
  if (!raw) return null;

  if (/^new\s+Date\s*\(\s*\)$/.test(raw)) return 'today';

  const literal = raw.match(/^["']([^"']+)["']$/);
  if (literal) return literal[1];

  return null;
}
